var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.tagsHaveBeenPreloaded
    ? _c("form", [
        _c("div", { staticClass: "dashboard-page-title" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _c("h1", [_vm._v("What you are known for")]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-info",
                attrs: { "active-class": "" },
                on: {
                  click: function ($event) {
                    return _vm.$router.go(-1)
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-chevron-left" }),
                _vm._v(" Back\n      "),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "dashboard-block" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-10 col-lg-8" },
                [
                  _c("div", { staticClass: "panel panel-grey" }, [
                    _c(
                      "div",
                      { staticClass: "panel-body" },
                      [
                        !_vm.$isNflClub
                          ? _c(
                              "div",
                              [
                                _c("h3", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$isNrlClient
                                        ? "Category"
                                        : _vm.$isWSL
                                        ? "Your nations"
                                        : _vm.$isQas
                                        ? "Tracking Category"
                                        : "What sports have you played?"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("tags", {
                                  attrs: { type: "sport" },
                                  model: {
                                    value: _vm.sportTags,
                                    callback: function ($$v) {
                                      _vm.sportTags = $$v
                                    },
                                    expression: "sportTags",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  _vm._l(_vm.sportTags, function (tag) {
                                    return _c(
                                      "li",
                                      {
                                        key: tag.id,
                                        staticStyle: {
                                          "list-style-type": "none",
                                        },
                                        attrs: { sync: true },
                                      },
                                      [
                                        _c("div", { staticClass: "col-xs-8" }, [
                                          _vm._v(
                                            "\n                        Are you still playing " +
                                              _vm._s(tag.name) +
                                              "?\n                      "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-xs-4" },
                                          [
                                            tag.pivot &&
                                            tag.pivot.retired === null
                                              ? _c("toggle-button", {
                                                  attrs: {
                                                    sync: true,
                                                    color: {
                                                      checked: "#565656",
                                                      unchecked: "#565656",
                                                    },
                                                    labels: {
                                                      checked: "UNSET",
                                                      unchecked: "UNSET",
                                                    },
                                                    width: 60,
                                                  },
                                                  model: {
                                                    value: tag.pivot.retired,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        tag.pivot,
                                                        "retired",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "tag.pivot.retired",
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            tag.pivot &&
                                            tag.pivot.retired !== null
                                              ? _c("toggle-button", {
                                                  attrs: {
                                                    sync: true,
                                                    color: {
                                                      checked: "#b7b7b7",
                                                      unchecked:
                                                        _vm.$brandPrimary,
                                                    },
                                                    labels: {
                                                      checked: "NO",
                                                      unchecked: "YES",
                                                    },
                                                  },
                                                  model: {
                                                    value: tag.pivot.retired,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        tag.pivot,
                                                        "retired",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "tag.pivot.retired",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "decorative-divider",
                                }),
                                _vm._v(" "),
                                _c("h3", [
                                  _vm._v("Your " + _vm._s(_vm.$t("Leagues"))),
                                ]),
                                _vm._v(" "),
                                _c("tags", {
                                  attrs: { type: "league" },
                                  model: {
                                    value: _vm.leagueTags,
                                    callback: function ($$v) {
                                      _vm.leagueTags = $$v
                                    },
                                    expression: "leagueTags",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  _vm._l(_vm.leagueTags, function (tag) {
                                    return _c(
                                      "li",
                                      {
                                        key: tag.id,
                                        staticStyle: {
                                          "list-style-type": "none",
                                        },
                                        attrs: { sync: true },
                                      },
                                      [
                                        _c("div", { staticClass: "col-xs-8" }, [
                                          _vm._v(
                                            "\n                        Are you still playing for " +
                                              _vm._s(tag.name) +
                                              "?\n                      "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-xs-4" },
                                          [
                                            tag.pivot &&
                                            tag.pivot.retired === null
                                              ? _c("toggle-button", {
                                                  attrs: {
                                                    sync: true,
                                                    color: {
                                                      checked: "#565656",
                                                      unchecked: "#565656",
                                                    },
                                                    labels: {
                                                      checked: "UNSET",
                                                      unchecked: "UNSET",
                                                    },
                                                    width: 60,
                                                  },
                                                  model: {
                                                    value: tag.pivot.retired,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        tag.pivot,
                                                        "retired",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "tag.pivot.retired",
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            tag.pivot &&
                                            tag.pivot.retired !== null
                                              ? _c("toggle-button", {
                                                  attrs: {
                                                    sync: true,
                                                    color: {
                                                      checked: "#b7b7b7",
                                                      unchecked:
                                                        _vm.$brandPrimary,
                                                    },
                                                    labels: {
                                                      checked: "NO",
                                                      unchecked: "YES",
                                                    },
                                                  },
                                                  model: {
                                                    value: tag.pivot.retired,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        tag.pivot,
                                                        "retired",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "tag.pivot.retired",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$highSchoolTags
                          ? [
                              _c("h3", [_vm._v("High School Attended")]),
                              _vm._v(" "),
                              _c("tags", {
                                attrs: { type: "highSchool" },
                                model: {
                                  value: _vm.highSchoolTags,
                                  callback: function ($$v) {
                                    _vm.highSchoolTags = $$v
                                  },
                                  expression: "highSchoolTags",
                                },
                              }),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$collegeTags
                          ? [
                              _c("div", { staticClass: "decorative-divider" }),
                              _vm._v(" "),
                              _c("h3", [_vm._v("College Attended")]),
                              _vm._v(" "),
                              _c("tags", {
                                attrs: { type: "college" },
                                model: {
                                  value: _vm.collegeTags,
                                  callback: function ($$v) {
                                    _vm.collegeTags = $$v
                                  },
                                  expression: "collegeTags",
                                },
                              }),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$degreeCompletedTags
                          ? [
                              _c("div", { staticClass: "decorative-divider" }),
                              _vm._v(" "),
                              _c("h3", [_vm._v("Degree Completed")]),
                              _vm._v(" "),
                              _c("tags", {
                                attrs: {
                                  type: "degreeCompleted",
                                  multiple: false,
                                  allowCreate: false,
                                },
                                model: {
                                  value: _vm.degreeCompletedTags,
                                  callback: function ($$v) {
                                    _vm.degreeCompletedTags = $$v
                                  },
                                  expression: "degreeCompletedTags",
                                },
                              }),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$firstContractTags
                          ? [
                              _c("div", { staticClass: "decorative-divider" }),
                              _vm._v(" "),
                              _c("h3", [_vm._v("Year Of First Contract")]),
                              _vm._v(" "),
                              _c("tags", {
                                attrs: {
                                  type: "firstContract",
                                  multiple: false,
                                  allowCreate: false,
                                },
                                model: {
                                  value: _vm.firstContractTags,
                                  callback: function ($$v) {
                                    _vm.firstContractTags = $$v
                                  },
                                  expression: "firstContractTags",
                                },
                              }),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "decorative-divider" }),
                        _vm._v(" "),
                        _c("h3", [
                          _vm._v(_vm._s(_vm.$t("Your club and/or event"))),
                        ]),
                        _vm._v(" "),
                        _c("tags", {
                          attrs: { type: "club" },
                          model: {
                            value: _vm.clubTags,
                            callback: function ($$v) {
                              _vm.clubTags = $$v
                            },
                            expression: "clubTags",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(_vm.clubTags, function (tag) {
                            return _c(
                              "li",
                              {
                                key: tag.id,
                                staticStyle: { "list-style-type": "none" },
                                attrs: { sync: true },
                              },
                              [
                                _c("div", { staticClass: "col-xs-8" }, [
                                  _vm._v(
                                    "\n                      Are you still playing for " +
                                      _vm._s(tag.name) +
                                      "?\n                    "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-4" },
                                  [
                                    tag.pivot && tag.pivot.retired === null
                                      ? _c("toggle-button", {
                                          attrs: {
                                            sync: true,
                                            color: {
                                              checked: "#565656",
                                              unchecked: "#565656",
                                            },
                                            labels: {
                                              checked: "UNSET",
                                              unchecked: "UNSET",
                                            },
                                            width: 60,
                                          },
                                          model: {
                                            value: tag.pivot.retired,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                tag.pivot,
                                                "retired",
                                                $$v
                                              )
                                            },
                                            expression: "tag.pivot.retired",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    tag.pivot && tag.pivot.retired !== null
                                      ? _c("toggle-button", {
                                          attrs: {
                                            sync: true,
                                            color: {
                                              checked: "#b7b7b7",
                                              unchecked: _vm.$brandPrimary,
                                            },
                                            labels: {
                                              checked: "NO",
                                              unchecked: "YES",
                                            },
                                          },
                                          model: {
                                            value: tag.pivot.retired,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                tag.pivot,
                                                "retired",
                                                $$v
                                              )
                                            },
                                            expression: "tag.pivot.retired",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.$positionTags
                          ? [
                              _c("div", { staticClass: "decorative-divider" }),
                              _vm._v(" "),
                              _c("h3", [
                                _vm._v(_vm._s(_vm.$t("Your position"))),
                              ]),
                              _vm._v(" "),
                              _c("tags", {
                                attrs: { type: "position" },
                                model: {
                                  value: _vm.positionTags,
                                  callback: function ($$v) {
                                    _vm.positionTags = $$v
                                  },
                                  expression: "positionTags",
                                },
                              }),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$awardTags
                          ? [
                              _c("div", { staticClass: "decorative-divider" }),
                              _vm._v(" "),
                              _c("h3", [_vm._v(_vm._s(_vm.$t("Your awards")))]),
                              _vm._v(" "),
                              _c("tags", {
                                attrs: { type: "award" },
                                model: {
                                  value: _vm.awardTags,
                                  callback: function ($$v) {
                                    _vm.awardTags = $$v
                                  },
                                  expression: "awardTags",
                                },
                              }),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$proBowlTags
                          ? [
                              _c("div", { staticClass: "decorative-divider" }),
                              _vm._v(" "),
                              _c("h3", [
                                _vm._v("Have you ever made it to a Pro Bowl?"),
                              ]),
                              _vm._v(" "),
                              _c("tags", {
                                attrs: {
                                  type: "proBowl",
                                  multiple: false,
                                  allowCreate: false,
                                },
                                model: {
                                  value: _vm.proBowlTags,
                                  callback: function ($$v) {
                                    _vm.proBowlTags = $$v
                                  },
                                  expression: "proBowlTags",
                                },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ladda-button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "submit",
                        click: _vm.handleSaveTagsCallback,
                      },
                    },
                    [_vm._v("\n            Save Changes\n          ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }